/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useRef, useEffect, useState } from "react";
import { Space, Input, Tooltip, message, Table, Button, Row } from "antd";

import { capitaliseWithHyphen, capitalize, serialNum } from "../../utils";

import { ReactComponent as Edit_icon } from "../../assests/images/edit-logo.svg";
import { ReactComponent as View_icon } from "../../assests/images/eyeIcon.svg";
import { ReactComponent as Assign_icon } from "../../assests/images/master/allocate.svg";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

import search_icon from "../../assests/images/search-icon.svg";
import Smcs_Loader from "../../assests/images/loader-new.gif";
// import Heading from "../../";
import useCustomNavigate from "../../components/customNavigationHook";
// import "./style.scss";
import Heading from "../../components/Heading";
import EllipsisWithTooltip from "../../components/EllipsisWithToolTip";

import { masterRateCardAPI } from "../../api/RateCardApi";
import "../viewBookingTable/viewBookingTabs/AllBookingTable.scss";
import Highlighter from "react-highlight-words";
import AssignRateCard from "./AssignRateCard";
// import "./style.scss";

const MasterRateCardList = ({ fetchRateList }) => {
  const debounceTimeout = useRef(null);
  const [inputSearchValue, setInputSearchValue] = useState("");
  let [tableData, setTableData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({});
  const [debouncedFilters, setDebouncedFilters] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [assignRateDetails, setAssignRateDetails] = useState({});
  const navigate = useCustomNavigate();
  useEffect(() => {
    getRateList({
      page: 1,
      limit: 10,
    });
  }, [fetchRateList]);

  const getRateList = async (params) => {
    setLoading(true);

    const response = await masterRateCardAPI.getAllRateList(params);
    if (response?.status) {
      const res = response?.response?.data;

      setTotalPageSize(res?.total);
      setLoading(false);
      setTableData(res?.items || []);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  // function handleIdClick(val) {
  //   localStorage.setItem(user, val);
  //   navigate(url);
  // }

  const reRoute = (pathName, rateCardName) => {
    navigate(pathName, {
      state: {
        view: true,

        rateCardName,
      },
    });
  };

  useEffect(() => {
    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      const handler = setTimeout(() => {
        getRateList({
          page: 1,
          limit: 10,

          ...debouncedFilters,
        });
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [debouncedFilters]);

  const handleTableChange = (pagination, filters) => {
    if (filters?.status) {
      getRateList({
        page: pagination?.current,
        limit: pagination.pageSize,
        status: filters?.status[0],
      });
    } else {
      getRateList({
        page: pagination?.current,
        limit: pagination.pageSize,
      });
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const handleSearch = (value, dataIndex) => {
    const updatedFilters = {
      ...filters,
      [dataIndex]: value?.toString(),
    };
    setFilters(updatedFilters);
    setDebouncedFilters(updatedFilters);
  };

  const getColumnSearchProps = (dataIndex, label = dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          placeholder={`Search ${label || dataIndex}`}
          value={selectedKeys[0] || ""}
          onChange={(e) => {
            const value = e.target.value ? [e.target.value] : [];
            setSelectedKeys(value);
            // console.log(dataIndex, "dataIndex");

            handleSearch(e.target.value, dataIndex);
          }}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
      </div>
    ),
    filterIcon: (filtered) => {
      //console.log(dataIndex, "dataIndex");

      return (
        <SearchOutlined
          style={{
            color: filters[dataIndex] ? "#1890ff" : undefined,
          }}
        />
      );
    },

    render: (text) => {
      return filters[dataIndex] ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[filters[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        formatText(text, 25) || "N/A"
      );
    },
  });

  const handleIdClick = (id, actionType) => {
    navigate(`/default-ratecard/${id}`, { state: { action: actionType } });
  };

  const columns = [
    {
      title: "SI",
      width: "8%",
      dataIndex: "sl",
      align: "center",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Template Name",
      dataIndex: "name",
      key: "name",
      width: "30%",
      render: (text, b) => formatText(text, 25),
      ...getColumnSearchProps("name", "Template Name"),
    },

    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "20%",
      render: (text) => text?.split("T")?.[0] || "N/A",
    },

    {
      title: "Actions",
      key: "action",
      align: "center",
      className: "actions-col",
      width: "20%",
      render: (_, record) => {
        return (
          <Space size="small">
            <Tooltip title="Edit" placement="bottom">
              <p
                className="pointer"
                style={{ marginBottom: 0 }}
                onClick={() => handleIdClick(record?.rateCardId, "EDIT")}
              >
                <Edit_icon width={25} height={25} />
              </p>
            </Tooltip>
            <Tooltip title="View" placement="bottom">
              <p
                className="pointer"
                style={{ marginBottom: 0 }}
                onClick={() => handleIdClick(record?.rateCardId, "VIEW")}
              >
                <View_icon width={25} height={25} />
              </p>
            </Tooltip>
            <Tooltip title="Assign" placement="bottom">
              <p
                className="pointer"
                style={{ marginBottom: 0 }}
                onClick={() => {
                  setIsModalOpen(true);
                  setAssignRateDetails(record);
                }}
              >
                <Assign_icon width={25} height={25} />
              </p>
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  // const onSearch = (e) => {
  //   const currValue = e.target.value;
  //   setInputSearchValue(currValue);

  //   const filteredData =
  //     inputSearchValue.length > 0 || inputSearchValue.length == 0
  //       ? filterArray(tableData, currValue)
  //       : filterArray(tableData, currValue);
  //   setdataSource(filteredData);
  // };

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const onSearch = (e) => {
    const currValue = e.target.value;
    setPageNum(0);
    setPageSize(pageSize);
    setInputSearchValue(currValue);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      //getClientApprovalList(0, 20, currValue);
      getRateList(
        `?pageNum=${pageNum}&pageSize=${pageSize}&search=${currValue}`
      );
    }, 500);
  };

  const handlePageChange = (pagination, filters) => {
    if (filters?.status) {
      getRateList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,

        status: filters?.status[0],
      });
    } else {
      getRateList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
      });
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  return (
    <>
      <div className="master-main-container ml-1 mr-1 table-container">
        <div className="align-center flex-end">
          {/* <div className="pl-1-5 fw-600"></div> */}
          {/* <div className="p-1">
            <Input
              placeholder="Search by keyword"
              bordered
              onChange={onSearch}
              style={{ borderRadius: "5px", height: "40px", width: "400px" }}
              suffix={<img src={search_icon} />}
            />
          </div> */}
          <Row className="p-05">
            <Button
              className="cancel-btn mr-1"
              style={{ minWidth: "5%" }}
              icon={<ReloadOutlined style={{ fontSize: "15px" }} />}
              onClick={() => {
                getRateList({
                  page: 1,
                  limit: 10,
                });
              }}
            >
              {" "}
              Reload
            </Button>
          </Row>
        </div>
        <Table
          className="table-head-sticky"
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),
            spinning: loading,
          }}
          columns={columns}
          onChange={handleTableChange}
          dataSource={tableData}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalPageSize,
            pageSizeOptions: ["10", "20", "50", "100"],
            showSizeChanger: true,
            itemRender: itemRender,
          }}
        />
        <AssignRateCard
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          assignRateDetails={assignRateDetails}
        />
      </div>
    </>
  );
};

export default MasterRateCardList;
